import { Box, HStack } from '@chakra-ui/react';
import { Heading, Text, Image } from '@chakra-ui/react';

import image from '../../presentation/assets/images/scene7.png';

const CTA = () =>
(
    <Box h="380px">
        <Image boxSize="100%" objectFit="cover" src={image} alt="Be Shaka" />
        <Box mt="-250px">
        <Heading as="h2" align="center" size="2xl" color="white">LEAVE YOUR<br/>CONFORT ZONE</Heading>
        <HStack mt="10px" justifyContent="center">
            <Text fontSize="2xl" color="white">Be</Text>
            <Text mt="10px" fontFamily="Dead Stock" fontSize="3xl" color="white">SHAKA</Text>
        </HStack>
        </Box>
    </Box>
);

export default CTA;